import React from 'react';

import Thumb from '../img/blogs/some-html-and-css-interview-questions.jpg';

const SomeHTMLAndCSSInterviewQuestions = {
    id: 16, permalink: "some-html-and-css-interview-questions", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 11, 2020", categories: "HTML, CSS", title: "Some HTML And CSS Interview Questions", shortDesc: "When you want a Web Developer job, In the Interview you might be faced with HTML and CSS related questions. So, here are some most Interview Questions about HTML and CSS.", fullDesc: <>
        <p>When you want a <strong>Web Developer</strong> job, In the <strong>Interview</strong> you might be faced with <strong>HTML and CSS</strong> related questions. So, here are some most <strong>Interview Questions</strong> about <strong>HTML and CSS</strong>, that can help you in the <strong>Interview</strong>.</p>


        <h2>HTML</h2>
        <h2>What is &lt;!DOCTYPE&gt;?</h2>
        <p><code>&lt;!DOCTYPE&gt;</code> instructed the <strong>browser</strong> to inform about the version of the <strong>HTML document</strong> and how the <strong>browser</strong> should render it.</p>

        <pre className="code">
            &lt;!DOCTYPE html&gt;
        </pre>

        <p>If the developer does not declare <code>&lt;!DOCTYPE&gt;</code> in the code, it will not support new features and tags that <strong>HTML5</strong> provides, such as <code>&lt;article&gt;</code>, <code>&lt;footer&gt;</code>, <code>&lt;header&gt;</code> etc.</p>

        <p>This is the first tag of the <strong>HTML file</strong>, no closing tag is required and is not case sensitive.</p>


        <h2>What is the difference between HTML elements and tags?</h2>
        <p>An <strong>HTML element</strong> is the collection of a start <strong>tag</strong>, its <strong>attributes</strong>, an end <strong>tag</strong>, and everything in between. On the other hand, an <strong>HTML tag</strong> is used to mark the start or end of an <strong>element</strong>.</p>


        <h2>What is semantic HTML?</h2>
        <p>A semantic element clearly describes its meaning to both the browser and the developer.</p>

        <p>Examples of non-semantic elements: <code>&lt;div&gt;</code> and <code>&lt;span&gt;</code> - Tells nothing about its content.</p>
        <p>Examples of semantic elements: <code>&lt;form&gt;</code>, <code>&lt;table&gt;</code>, and <code>&lt;article&gt;</code> - Clearly defines its content.</p>


        <h2>What are the HTML5 Structuring Tags?</h2>
        <p><em>Following are some of the tags that have been introduced in <strong>HTML5</strong> for better structuring</em>:</p>
        <ul>
            <li><strong><code>&lt;article&gt;</code></strong><br />
                <small>Defines an article.</small></li>

            <li><strong><code>&lt;aside&gt;</code></strong><br />
                <small>Defines content other than the page content.</small></li>

            <li><strong><code>&lt;bdo&gt;</code></strong><br />
                <small>(Bidirectional override) change the direction of HTML text.</small></li>

            <li><strong><code>&lt;command&gt;</code></strong><br />
                <small>Defines a command button to be invoked by the user.</small></li>

            <li><strong><code>&lt;details&gt;</code></strong><br />
                <small>Outlines the additional details that a user can hide or view as per choice.
                </small></li>

            <li><strong><code>&lt;dialog&gt;</code></strong><br />
                <small>Used to mark up a conversation.</small></li>

            <li><strong><code>&lt;figure&gt;</code></strong><br />
                <small>Used for associating a caption together with some embedded content such as a
                graphic or a video.</small></li>

            <li><strong><code>&lt;figcaption&gt;</code></strong><br />
                <small>Provides a caption for a <code>&lt;figure&gt;</code> element.</small></li>

            <li><strong><code>&lt;header&gt;</code></strong><br />
                <small>Represents the header of a section.</small></li>

            <li><strong><code>&lt;nav&gt;</code></strong><br />
                <small>Representing the section of a document that is intended for navigation.</
                small></li>

            <li><strong><code>&lt;footer&gt;</code></strong><br />
                <small>Representing a footer of a section.</small></li>

            <li><strong><code>&lt;section&gt;</code></strong><br />
                <small>Representing a generic document or application section.</small></li>

            <li><strong><code>&lt;hgroup&gt;</code></strong><br />
                <small>When there are multiple levels in a heading, it groups a set of <code>&lt;h1&gt;</code> to <code>&lt;h6&gt;</code> elements.</small></li>
        </ul>


        <h2>How can you change direction of HTML text?</h2>
        <p>I can use <code>bdo</code> (bidirectional override) element of <strong>HTML</strong> to change the direction of <strong>HTML</strong> text.</p>

        <pre className="code">
            &lt;p&gt;&lt;bdo dir="rtl"&gt;Right to left direction text&lt;&#47;bdo&gt;&lt;&#47;p&gt;
        </pre>
        <p><strong>Expected Output:</strong> <code className="output"><bdo dir="rtl">Right to left direction text</bdo></code></p>


        <h2>CSS</h2>
        <h2>What are the differences between visibility hidden and display none?</h2>
        <p><code>display: none;</code> removes the element from the layout and allows other elements to be filled. <code>visibility: hidden;</code> tag is rendered, it takes space but does not display it.</p>


        <h2>How could you apply CSS rules specific to a media?</h2>
        <p><code>@media (max-width: 768px)&#123;...&#125;</code> means I want to apply rules to those media whose maximum width of <strong>768px</strong>. This means every small device (up to <strong>768px</strong> width) will have this rule.</p>


        <h2>How can you load CSS resources?</h2>
        <p><code>@import</code> lets us <strong>load/import stylesheets</strong> using a path (<strong>URI</strong>) representing the location of the file.</p>


        <h2>What is the purpose of the CSS filter?</h2>
        <p><strong>CSS</strong> filter allows us to render the <strong>DOM element, image, or video</strong>. We can choose from <strong>grayscale, blur, opacity, brightness, contrast</strong>.</p>


        <h2>What are the reasons to use preprocessor?</h2>
        <p>A <strong>preprocessor</strong> has its own syntax for <strong>developers</strong> to write easier and cleaner <strong>CSS code</strong>. We can write <strong>CSS</strong> at a high level with some special syntax (<strong>declaring variable, nested syntax, mathematical operations</strong>, etc). and that is compiled to <strong>CSS</strong>.</p>
    </>
};
export default SomeHTMLAndCSSInterviewQuestions;